import { render, staticRenderFns } from "./TodayReservationCards.vue?vue&type=template&id=857a59a2&scoped=true"
import script from "./TodayReservationCards.vue?vue&type=script&lang=js"
export * from "./TodayReservationCards.vue?vue&type=script&lang=js"
import style0 from "./TodayReservationCards.vue?vue&type=style&index=0&id=857a59a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857a59a2",
  null
  
)

export default component.exports